import { formatHmInBrussels } from '@/lib/brusselsSchedule';

/**
 * Horaires habituels UTA — alignés avec Contact / accueil.
 */
export const UTA_CONFERENCE_SCHEDULE_TEXT =
    'Les conférences ont lieu le vendredi de 14h30 à 16h30. Un café ou une boisson est servi après la conférence.';

/** Créneau par défaut (heure de Bruxelles) — modifiable par événement en base. */
export const UTA_EVENT_START_HM = '14:30';
export const UTA_EVENT_END_HM = '16:30';

/** @deprecated conservé pour compat ; tous les événements utilisent le créneau Bruxelles ci-dessus. */
export const DEFAULT_CONFERENCE_END_TIME = UTA_EVENT_END_HM;

/** « 14:30 » → « 14h30 » pour affichage. */
export function formatHmForDisplayFr(hm) {
    return String(hm ?? '').replace(':', 'h');
}

/** Heure de fin normalisée HH:mm depuis la colonne `end_time` (ex. 16:30:00). */
export function normalizeEndTimeToHm(endTime) {
    if (endTime == null || String(endTime).trim() === '') return UTA_EVENT_END_HM;
    const parts = String(endTime).trim().split(':');
    if (parts.length >= 2) {
        return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}`;
    }
    return UTA_EVENT_END_HM;
}

/** Libellé court « début – fin » pour un événement. */
export function formatEventScheduleLabel(event) {
    if (!event?.date) return `${UTA_EVENT_START_HM} – ${UTA_EVENT_END_HM}`;
    const start = formatHmInBrussels(event.date);
    const end = normalizeEndTimeToHm(event.end_time);
    return `${start} – ${end}`;
}
